<template>
    <div id="orders-list" class="orders-list-wrapper" tabindex="0">
        <div class="page-title">
            <h4> {{$t('txt.listaComenzi')}} </h4>
        </div>
        <div class="page-header-inner">
            <div class="table-header">
                <div class="search-box">
                    <div class="search-form">
                        <input
                                type="search"
                                name="q"
                                :placeholder="$t('placeholder.cautaComanda')"
                                id="user-search"
                                v-model="search"
                                autocomplete="off"
                                @change="applyQuery({ q: search })"
                        >
                        <span class="focus-input"></span>
                        <span class="symbol-input" @click="applyQuery({ q: search })">
                            <i class="fas fa-search"></i>
                        </span>
                    </div>
                    <button type="button" class="template-button" @click="$router.push('/orders/create')">
                        <i class="fas fa-plus-circle"></i> {{$t('txt.adaugaComanda')}}
                    </button>
                </div>
            </div>
            <div class="filters-section">
                <div class="show-filters" v-on:click="showFilters = !showFilters">
                    <i class="fas fa-angle-double-right first-angle"></i>
                    <h4>
                        {{$t('txt.filtreazaDupa')}}:
                    </h4>
                    <i class="fas fa-angle-double-left second-angle"></i>
                </div>
                <div class="filters-wrapper-inner" :class="{fwi_active:showFilters}">
                    <div class="filters-wrapper-main">
                        <div class="filters-select">
                            <div class="filterSelection">
                                <label> {{$t('placeholder.angajat')}} </label>
                                <v-select v-model="filters.employee" :options="this.employees" placeholder="angajat" :get-option-label="partnerName"></v-select>
                            </div>
                            <div class="filterSelection">
                                <label> {{$t('placeholder.colaborator')}}: </label>
                                <v-select v-model="filters.partner" :options="this.partners" :get-option-label="partnerName" placeholder="colaborator"></v-select>
                            </div>
                         </div>
                    </div>
                    <div class="close-filters" v-on:click="showFilters = !showFilters">
                        <i class="far fa-times-circle"></i>
                    </div>
                    <div class="date-filter">
                        <h4> {{$t('txt.data')}}: </h4>
                        <div class="date-filter-wrapper">
                            <div class="form-group custom-error-group2">
                                <date-picker placeholder="Incepand de la" v-validate="'required'" name="date1" v-model="start_date"  type="date" lang="en" format="DD-MM-YYYY"></date-picker>
<!--                                <p class="custom-error-info"> {{errors.first('date')}} </p>-->
                            </div>
                            <div class="form-group custom-error-group2">
                                <date-picker placeholder="Pana la" v-validate="'required'" name="date2" v-model="end_date"  type="date" lang="en" format="DD-MM-YYYY"></date-picker>
<!--                                <p class="custom-error-info"> {{errors.first('date')}} </p>-->
                            </div>
                        </div>
<!--                        <div class="filter-date-button">-->
<!--                            <button @click.prevent='searchByDate()' :disabled="this.$store.state.loading">-->
<!--                                <i class="fas fa-search"></i>-->
<!--                                {{$t('placeholder.cauta')}}-->
<!--                            </button>-->
<!--                        </div>-->
                    </div>
                    <div class="filters-button">
                        <button type="button" class="reset-filters" @click="resetFilters()">
                            <i class="fas fa-undo"></i>
                            {{$t('txt.reseteazaFiltre')}}
                        </button>
                        <button type="button" @click="filterUsers()">
                            {{$t('txt.filtreaza')}}
                            <i class="fas fa-filter"></i>
                        </button>
                    </div>
                </div>
            </div>
            <!--<div class="filters-section">
                <div class="show-filters" v-on:click="showFilters = !showFilters">
                    <i class="fas fa-angle-double-right first-angle"></i>
                    <h4>
                        {{$t('txt.filtreazaDupa')}}:
                    </h4>
                    <i class="fas fa-angle-double-left second-angle"></i>
                </div>
                <div class="filters-wrapper-inner" :class="{fwi_active:showFilters}">
                    <div class="filters-wrapper-main">
                        <div class="filters-select">
                            <div class="filterSelection">
                                <label> {{$t('placeholder.judet')}}: </label>
                                <v-select v-model="filters.county" :options="this.counties" label="name"
                                          @input="getCitiesByCounty()" placeholder="Judet"></v-select>
                            </div>
                            <div class="filterSelection">
                                <label> {{$t('placeholder.oras')}} </label>
                                <v-select v-model="filters.city" :options="this.cities" label="name"></v-select>
                            </div>
                        </div>
                    </div>
                    <div class="filters-button">
                        <button type="button" class="reset-filters" @click="resetFilters()">
                            <i class="fas fa-undo"></i>
                            {{$t('txt.reseteazaFiltre')}}
                        </button>
                        <button type="button" @click="filterUsers()">
                            {{$t('txt.filtreaza')}}
                            <i class="fas fa-filter"></i>
                        </button>
                    </div>
                    <div class="close-filters" v-on:click="showFilters = !showFilters">
                        <i class="far fa-times-circle"></i>
                    </div>
                </div>
            </div>-->
        </div>
        <div class="utilities-result-wrapper" v-if="this.$route.query.q">
            <p class="search-result" v-if="this.$route.query.q">
                <i class="fas fa-poll-h"></i>
                {{$t('txt.cautareDupa')}} "{{this.searchBy}}"
            </p>
        </div>
        <div class="mobile-sorting">
            <div class="mobile-sort-by">
                <v-select :options="this.tableColumns"
                          v-model="sortMobile.sortMobileBy"
                          @input="handleSortMobile(sortMobileBy, sortMobileType)"
                          label="tableHeader"
                          :placeholder="$t('txt.sorteazaDupa')">
                </v-select>
            </div>
            <div class="mobile-sort-method">
                <v-select :options="this.mobileSortingType"
                          v-model="sortMobile.sortMobileType"
                          @input="handleSortMobile(sortMobileBy, sortMobileType)"
                          label="name"
                          :placeholder="$t('txt.criteriuSortare')">
                </v-select>
            </div>
        </div>
        <div class="legend-template">
            <p class="new-order" @click="filterUsers( 1  )"> Noua </p>
            <p class="order-ready" @click="filterUsers( 2  )"> Pregatita de livrare </p>
            <p class="order-finalized" @click="filterUsers( 3  )"> Finalizata </p>
            <p class="order-canceled" @click="filterUsers( 4 )"> Anulata </p>
            <div class="reset-sort-status reset-sortorder-status" @click="resetOrderStatus()">
                <p class="status-dots-wrapper">
                    <span class="dot dot-new"></span>
                    <span class="dot dot-ready"></span>
                </p>
                <p class="hidden-text"> Reseteaza  </p>
                <p class="status-dots-wrapper">
                    <span class="dot dot-finalized"></span>
                    <span class="dot dot-canceled2"></span>
                </p>
            </div>
        </div>
        <table class="table app_table" id="table-resize">
            <thead>
            <tr class="app_table_header">
                <th scope="col" v-for="(column, index) in tableColumns" :key="index">
                    <span v-if="column.sortable" @click="handleSort(column.sortBy)" >
                        {{column.tableHeader}}
                        <span class="sort-arrow" v-if="$route.query.sort_by === column.sortBy && $route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                        <span class="sort-arrow" v-else-if="$route.query.sort_by === column.sortBy && $route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                        <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </span>
                    <span v-else>
                        {{column.tableHeader}}
                    </span>
                </th>
                <th scope="col"> {{$t('tableHeader.optiuni')}}</th>
            </tr>
            </thead>
            <tbody v-if="results">
            <tr v-for="(row, index) in results" @click="lastDataActive = index" :key="index" :data-active="index" :data-popover="'popover-' + index" :class="statusColor.find(value => value.status === row.status).label" @dblclick="$router.push({ name: 'vieworder', params: { id: row.id }})" @keyup.enter="$router.push({ name: 'vieworder', params: { id: row.id }})" tabindex="3" :id="'popover-' + index" variant="primary">
                    <td v-for="(column, indexColumn) in tableColumns" :key="indexColumn" :tableheadData="column.tableHeader">
                        <span v-if="column.sortBy === 'id'">
                          <i v-if="parseInt(row.processed_mentor) === 1" class="fas fa-caret-up" style="color: green; font-size: 22px" v-b-tooltip.hover title="Procesata Mentor"></i>
                          <i v-else class="fas fa-caret-down" style="color: red; font-size: 22px" v-b-tooltip.hover title="Neprocesata Mentor (Pentru a reincerca procesarea salvati comanda din editare comanda)"></i>
                        </span>
                        <span v-if="column.sortBy === 'employee'">
                            {{(row['employee']) ? clientName(row['employee']) : '-'}}
                        </span>
                        <span v-else-if="column.sortBy === 'partner'">
                            {{(row['partner']) ? clientName(row['partner']) : '-'}}
                        </span>
                        <span v-else-if="column.sortBy === 'client'">
                            {{(row['client']) ? clientName(row['client']) : '-'}}
                        </span>
                        <span v-else>
                            {{(row[column.value] && column.get) ? row[column.value][column.get] : ((row[column.value]) ? row[column.value] : '-')}}
                        </span>
                    </td>
                    <td :tableheadData="$t('tableHeader.optiuni')" class="options-case">
                        <a :href="row.media[row.media.length - 1]['link']"
                           class="convo-doc" target="_blank"
                           v-if="row.media[0]" data-placement="top"
                           data-toggle="tooltip" :title="$t('placeholder.vizualizeaza')"
                        >
                            <i class="far fa-file-alt"></i>
                        </a>
                        <router-link :to="{ name: 'vieworder', params: { id: row.id }}" class="view-user"
                                     data-placement="top" data-toggle="tooltip" :title="$t('placeholder.vizualizeaza')">
                            <i class="fas fa-eye"></i>
                        </router-link>
                        <router-link :to="{ name: 'editorder', params: { id: row.id }}" class="edit-user"
                                     data-placement="top" data-toggle="tooltip" :title="$t('placeholder.editeaza')">
                            <i class="fas fa-pen"></i>
                        </router-link>
                        <a href="javascript:void(0)" class="delete-user" data-placement="top" data-toggle="tooltip"
                           :title="$t('placeholder.sterge')" @click="remove(index, row.id)">
                            <i class="fas fa-trash-alt"></i>
                        </a>
                    </td>
                    <b-popover :target="'popover-' + index" triggers="hover focus" placement="bottomleft" delay="100">
                        <template slot="title">
                            Produse
                        </template>

                        <ol class="popover-content">
                            <li v-for="product in row.products" :key="product.id">
                                <p>
                                    {{product.name}}
                                </p>
                            </li>
                            <li  v-for="service in row.services" :key="service.id">
                                <p>
                                    {{service.name}}
                                </p>
                            </li>
                            <li v-for="post_service in row.post_services" :key="post_service.id">
                                <p>
                                    {{post_service.name}}
                                </p>
                            </li>
                        </ol>
                    </b-popover>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td colspan="8" v-if="this.$store.state.loading">{{$t('txt.loading')}}</td>
                    <td colspan="8" v-else>{{$t('errors.emptyResult')}}</td>
                </tr>
            </tbody>
            <tfoot v-if="results">
                <tr class="app_table_header">
                    <th scope="col" v-for="(column, index) in tableColumns" :key="index">
                        {{column.tableHeader}}
                    </th>
                    <th scope="col">
                        {{$t('tableHeader.optiuni')}}
                    </th>
                </tr>
            </tfoot>
        </table>
        <div class="col-lg-12 col-md-12" v-if="results">
            <div class="pagination-wrapper">
                <div class="results-message">
                    <p>
                        <i class="fas fa-info-circle"></i>
                        {{$t('pagination.info', { from: this.meta.from, to: this.meta.to, total: this.meta.total })}}
                    </p>
                    <div class="filter-results-number">
                        <label> {{$t('txt.afiseaza')}}: </label>
                        <select v-model="filters.per_page" @change="applyQuery({ per_page: filters.per_page })">
                            <option value="25"> {{$t('txt.rezultatePePagina',{nr:25})}} </option>
                            <option value="50"> {{$t('txt.rezultatePePagina',{nr:50})}} </option>
                            <option value="100"> {{$t('txt.rezultatePePagina',{nr:100})}} </option>
                        </select>
                    </div>
                </div>
                <ul class="pagination-box">
                    <li class="pagination-point" v-if="this.meta.current_page !== 1">
                        <a href="javascript:void(0)" @click="applyQuery({ page: 1 })" class="Previous"><i
                                class="fas fa-angle-double-left pag-left"></i></a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== 1">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.current_page-1 })"
                           class="Previous"><i class="fas fa-angle-left pag-left"></i></a>
                    </li>
                    <li class="pp-dot" v-for="page in pagination"
                        :class="{'pp-dot-active': meta.current_page === page }" :key="page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: page })">{{page}}</a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== this.meta.last_page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.current_page+1 })"><i
                                class="fas fa-angle-right pag-right"></i> </a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== this.meta.last_page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.last_page })"> <i
                                class="fas fa-angle-double-right pag-right"></i></a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import OrdersService from '../../api-services/orders.service.js'
import EmployeesService from '../../api-services/employees.service.js'
import PartnersService from '../../api-services/partners.service'
export default {
  name: 'Orders',
  data () {
    return {
      statusColor: [
        { label: 'row-status-new', status: 'comanda noua' },
        { label: 'row-status-ready', status: 'pregatita de livrare' },
        { label: 'row-status-finalized', status: 'finalizata' },
        { label: 'row-status-canceled', status: 'anulata' }
      ],
      tableColumns: [
        {
          sortBy: 'id',
          tableHeader: this.$t('tableHeader.id'),
          sortable: true,
          value: 'id',
          get: null
        },
        {
          sortBy: 'client',
          tableHeader: this.$t('tableHeader.client'),
          sortable: true,
          value: '',
          get: null
        },
        {
          sortBy: 'employee',
          tableHeader: this.$t('tableHeader.employee'),
          sortable: true,
          value: '',
          get: null
        },
        {
          sortBy: 'partner',
          tableHeader: this.$t('tableHeader.partner'),
          sortable: true,
          value: '',
          get: null
        },
        {
          sortBy: 'data',
          tableHeader: this.$t('tableHeader.data'),
          sortable: true,
          value: 'created_at',
          get: null
        },
        {
          sortBy: 'county',
          tableHeader: this.$t('tableHeader.judet'),
          value: 'client',
          sortable: true,
          get: 'county'
        },
        {
          sortBy: 'city',
          tableHeader: this.$t('tableHeader.oras'),
          value: 'client',
          sortable: true,
          get: 'city'

        },
        {
          sortBy: 'total',
          tableHeader: this.$t('tableHeader.total'),
          sortable: true,
          value: 'total',
          get: null
        },
        {
          sortBy: 'pts_rewards_employee',
          tableHeader: this.$t('tableHeader.puncteDeRecompensareAngajat'),
          sortable: true,
          value: 'reward_points_employee',
          get: null
        },
        {
          sortBy: 'pts_rewards_partner',
          tableHeader: this.$t('tableHeader.puncteDeRecompensareColaborator'),
          sortable: true,
          value: 'reward_points_partner',
          get: null
        },
        {
          sortBy: 'objective',
          tableHeader: this.$t('tableHeader.obiectiv'),
          sortable: true,
          value: 'objective',
          get: null
        },
        {
          sortBy: 'representative_products',
          tableHeader: this.$t('tableHeader.produseReprezentative'),
          sortable: true,
          value: 'representative_products',
          get: null
        }
        /* {
          sortBy: 'status',
          tableHeader: this.$t('tableHeader.status'),
          sortable: true,
          value: 'status',
          get: null
        } */
      ],
      sortMobile: {
        sortMobileBy: null,
        sortMobileType: null
      },
      start_date: null,
      end_date: null,
      results: null,
      partners: [],
      employees: [],
      filters: {
        client: null,
        employee: null,
        partner: null,
        per_page: 25
      },
      mobileSorting: [
        { key: 'id', name: 'Nr' },
        { key: 'client', name: 'Client' },
        { key: 'employee', name: 'Employee' },
        { key: 'partner', name: 'Partner' },
        { key: 'data', name: 'Data' },
        { key: 'county', name: 'Judet' },
        { key: 'city', name: 'Oras' },
        { key: 'total', name: 'Total' },
        { key: 'status', name: 'Status' }
      ],
      mobileSortingType: [
        { key: 'ASC', name: 'Crescator' },
        { key: 'DESC', name: 'Descrescator' }
      ],
      search: '',
      searchBy: this.$route.query.q || null,
      showFilters: (this.$route.query.f_employee && this.$route.query.f_partner > 0) || (this.$route.query.f_partner && this.$route.query.f_employee > 0),
      meta: {},
      c_status: 0,
      lastDataActive: null
    }
  },
  watch: {
    search: function (value) {
      if (!value) {
        this.applyQuery({ q: value })
      }
    },
    '$route.query' () {
      this.getOrders()
    }
  },
  computed: {
    startDate () {
      // console.log(this.start_date,'STARRRRRRRRRRRRRRTTTTT')
      let startDate = new Date(this.start_date)
      // console.log(this.start_date, 'this.start_date', startDate, 'STARTDATE')
      // startDate = startDate.getFullYear() + '-' + ('0' + (startDate.getMonth() + 1)).slice(-2) + '-' + ('0' + startDate.getDate()).slice(-2)
      // startDate = startDate.toLocaleDateString("en-US")
      startDate = startDate.getFullYear() + '-' + ('0' + (startDate.getMonth() + 1)).slice(-2) + '-' + ('0' + startDate.getDate()).slice(-2)

      return startDate
    },
    endDate () {
      // console.log('ENDDATETETETETETET')
      let endDate = new Date(this.end_date)
      // console.log(this.end_date, 'ENDDATE', endDate, '--endate')
      // endDate = endDate.getFullYear() + '-' + ('0' + (endDate.getMonth() + 1)).slice(-2) + '-' + ('0' + endDate.getDate()).slice(-2)
      // endDate = endDate.toLocaleDateString("en-US")
      endDate = endDate.getFullYear() + '-' + ('0' + (endDate.getMonth() + 1)).slice(-2) + '-' + ('0' + endDate.getDate()).slice(-2)
      return endDate
    },
    sortMobileBy () {
      return (this.sortMobile.sortMobileBy) ? this.sortMobile.sortMobileBy.sortBy : null
    },
    sortMobileType () {
      return (this.sortMobile.sortMobileType) ? this.sortMobile.sortMobileType.key : null
    },

    // return first page from pagination html
    start_page () {
      if (this.meta.last_page > 5 && this.meta.current_page > 2) {
        return parseInt(this.meta.current_page, 10) - 2
      } else {
        return 1
      }
    },
    // return last page from pagination html
    stop_page () {
      if (this.meta.last_page > 5 && this.meta.current_page + 2 < this.meta.last_page) {
        return parseInt(this.meta.current_page, 10) + 2
      } else {
        return this.meta.last_page
      }
    },
    // return only 5 pages for pagination
    pagination () {
      let pages = []
      for (let i = this.start_page; i <= this.stop_page; i++) {
        pages.push(i)
      }
      return pages
    }
  },
  components: {
    DatePicker
  },
  methods: {
    // searchByDate () {
    //   if (this.start_date !== '' && this.end_date !== '') {
    //     this.applyQuery({ 'start_date': this.startDate, 'end_date': this.endDate })
    //   }
    // },
    getEmployees () {
      return new Promise((resolve, reject) => {
        EmployeesService.getAll({ per_page: -1 })
          .then((response) => {
            this.employees = response.data.data
            resolve(this.employees)
          })
          .catch((error) => {
            console.log(error)
          })
      })
    },
    getCollaborators () {
      return new Promise((resolve, reject) => {
        PartnersService.getAll({ per_page: -1 })
          .then((response) => {
            this.partners = response.data.data
            resolve(this.partners)
          })
          .catch((error) => {
            console.log(error)
          })
      })
    },
    getOrders () {
      this.results = null
      this.$store.dispatch('showLoading')
      OrdersService.getAll()
        .then((response) => {
          if (response.data.data.length > 0) {
            this.results = response.data.data
          } else {
            this.results = null
          }
          this.meta = response.data.meta
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          let message = error.response.data.error
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: message,
            'animation-type': 'css'
          })
          this.$store.dispatch('hideLoading')
        })
    },

    // Send and Apply query params in url
    applyQuery (params) {
      let resetPage = { page: '1' }
      let currentQuery = this.$route.query
      if (params.q) {
        this.searchBy = this.search
      }
      // params = _.pickBy(params)
      // merge 3 objects
      let query = { ...currentQuery, ...resetPage, ...params }
      this.$router.push({ name: 'orders', query: query })
    },
    // Apply sort params on column
    handleSort (column) {
      if (this.$route.query.sort_by === column && this.$route.query.sort_type === 'ASC') {
        this.applyQuery({ sort_by: column, sort_type: 'DESC' })
      } else {
        this.applyQuery({ sort_by: column, sort_type: 'ASC' })
      }
    },
    handleSortMobile (column, type) {
      if (column) {
        if (!this.sortMobile.sortMobileBy) {
          let found = this.tableColumns.find(function (element) {
            return element.name === column
          })
          this.sortMobile.sortMobileBy = found
        }
        if (type) {
          if (!this.sortMobile.sortMobileType) {
            let found = this.mobileSortingType.find(function (element) {
              return element.key === type
            })
            this.sortMobile.sortMobileType = found
          }
        } else {
          if (!this.sortMobile.sortMobileType) {
            let found = this.mobileSortingType.find(function (element) {
              return element.key === 'ASC'
            })
            this.sortMobile.sortMobileType = found
          }
          type = this.sortMobile.sortMobileType.key
        }
        this.applyQuery({ sort_by: column, sort_type: type })
      } else {
        this.applyQuery({ sort_by: null, sort_type: null })
      }
    },
    filterUsers (status) {
      if (status) {
        this.c_status = status
        this.applyQuery({ c_status: status })
      } else if (this.filters.employee && this.filters.partner) {
        if (this.start_date !== null && this.end_date !== null) {
          this.applyQuery({ f_employee: this.filters.employee.id,
            f_partner: this.filters.partner.id,
            start_date: this.startDate,
            end_date: this.endDate,
            c_status: status || this.c_status
          })
        } else {
          this.applyQuery({ f_employee: this.filters.employee.id,
            f_partner: this.filters.partner.id
          })
        }
      } else if (this.filters.partner) {
        // let newRouteQuery = _.omit(this.$route.query, 'f_city')
        // this.$router.replace( { query: newRouteQuery } )
        if (this.start_date !== null && this.end_date !== null) {
          this.applyQuery({ f_partner: this.filters.partner.id,
            f_employee: 0,
            start_date: this.startDate,
            end_date: this.endDate,
            c_status: status || this.c_status
          })
        } else {
          this.applyQuery({ f_partner: this.filters.partner.id,
            f_employee: 0,
            c_status: status || this.c_status
          })
        }
      } else if (this.filters.employee) {
        if (this.start_date !== null && this.end_date !== null) {
          this.applyQuery({ f_employee: this.filters.employee.id,
            f_partner: 0,
            start_date: this.startDate,
            end_date: this.endDate,
            c_status: status || this.c_status
          })
        } else {
          this.applyQuery({ f_employee: this.filters.employee.id,
            f_partner: 0,
            c_status: status || this.c_status
          })
        }
      } else if (this.start_date !== null && this.end_date !== null) {
        this.applyQuery({
          start_date: this.startDate,
          end_date: this.endDate })
      }
      this.showFilters = false
    },
    resetOrderStatus () {
      this.applyQuery({ c_status: 0 })
    },
    resetFilters () {
      this.filters.client = null
      this.filters.employee = null
      this.filters.partner = null
      this.start_date = null
      this.end_date = null
      this.c_status = null
      this.applyQuery({ page: 1, f_partner: 0, f_employee: 0, end_date: null, start_date: null, c_status: null })
      this.showFilters = false
    },
    remove (index, id) {
      this.$swal.fire({
        title: this.$t('txt.suntetiSigur'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('txt.stergeComanda'),
        cancelButtonText: this.$t('txt.anuleaza')
      }).then((result) => {
        if (result.value) {
          OrdersService.delete(id)
            .then((response) => {
              this.$store.dispatch('userRequest')
              this.$delete(this.results, index)
            })
            .catch((error) => {
              let message = error.response.data.error
              this.$notify({
                group: 'error',
                type: 'error',
                title: 'Error',
                text: message,
                'animation-type': 'css'
              })
            })
        }
      })
    }
  },
  mounted () {
    window.$('#orders-list').focus()
    let vm = this
    document.getElementById('orders-list').addEventListener('keydown', event => {
      if ((event.keyCode === 40 || event.keyCode === 38) && document.activeElement.closest('.orders-list-wrapper') !== null) {
        event.preventDefault()
        let target = window.$('html, body')
        if (event.keyCode === 40) {
          vm.lastDataActive = vm.lastDataActive == null ? 0 : vm.lastDataActive + 1
          if (vm.lastDataActive > this.results.length) {
            vm.lastDataActive--
          }
          if (vm.lastDataActive === this.results.length) {
            target.animate({
              scrollTop: target.height()
            }, 'fast')
            window.$('[data-active=' + vm.lastDataActive + ']').focus()
            return false
          }
        } else {
          vm.lastDataActive = vm.lastDataActive < 1 ? 0 : vm.lastDataActive - 1
          if (vm.lastDataActive === 3) {
            target.animate({
              scrollTop: 0
            }, 'fast')
            window.$('[data-active=' + vm.lastDataActive + ']').focus()
            return false
          }
        }
        window.$('[data-active=' + vm.lastDataActive + ']').focus()
      }
    })
  },
  async created () {
    this.getOrders()
    this.getCollaborators()
    this.getEmployees()
    let query = this.$route.query
    if (query.start_date) {
      this.start_date = new Date(query.start_date)
    }
    if (query.end_date) {
      this.end_date = new Date(query.end_date)
    }
    if (query.f_partner) {
      this.filters.partner = this.partners.find(partner => parseInt(partner.id) === parseInt(query.f_partner))
    }
    if (query.f_employee) {
      this.filters.employee = this.employees.find(employee => parseInt(employee.id) === parseInt(query.f_employee))
    }
    if (query.c_status) {
      this.c_status = query.c_status
    }

    if (query.q) this.search = query.q
    // this.getCounties()
    if (query.sort_by && query.sort_type) {
      this.handleSortMobile(query.sort_by, query.sort_type)
    } else if (query.sort_by) {
      this.handleSortMobile(query.sort_by)
    }
    if (window.innerWidth < 700) {
      let valuesArr = this.tableColumns
      let removeValFromIndex = [2, 3, 5, 6, 8, 9]
      for (let i = removeValFromIndex.length - 1; i >= 0; i--) {
        valuesArr.splice(removeValFromIndex[i], 1)
      }
    } else if (window.innerWidth < 970) {
      let valuesArr = this.tableColumns
      let removeValFromIndex = [2, 3, 8, 9]
      for (let i = removeValFromIndex.length - 1; i >= 0; i--) {
        valuesArr.splice(removeValFromIndex[i], 1)
      }
    } else if (window.innerWidth < 1470) {
      let valuesArr = this.tableColumns
      let removeValFromIndex = [8, 9]
      for (let i = removeValFromIndex.length - 1; i >= 0; i--) {
        valuesArr.splice(removeValFromIndex[i], 1)
      }
    }
    // if (query.f_county) this.getCitiesByCounty(query.f_county)
  }
}
</script>
